import { render } from "./PizzaMenu.vue?vue&type=template&id=2e3bd12a"
import script from "./PizzaMenu.vue?vue&type=script&lang=js"
export * from "./PizzaMenu.vue?vue&type=script&lang=js"

import "./PizzaMenu.vue?vue&type=style&index=0&id=2e3bd12a&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\alternativa-takeaway-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__